module.exports = __webpack_public_path__ + "img/icash.b4e26bee.svg";